import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const ScheduleListContainer = styled.div<{ fixed?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: nowrap;

  ${({ fixed }) => (fixed ? '' : `
    border-top: 15px solid ${colors.brand.principal};
    border-radius: 5px;
  `)}

  width: 792px;

  @media (max-width: 768px) {
    width: 80vw;
  }
`;

export const TotalContainer = styled.div<{ fixed?: boolean }>`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ fixed }) => (fixed ? `
    height: 86px;
    border-left: 1px solid lightgrey;
    border-right: 1px solid lightgrey;
    border-top-right-radius: 8px;
  ` : '')}

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;

    & > div {
      margin: 0 !important;
    }
  }
`;

export const ListContainer = styled.div<{ fixed?: boolean }>`
  padding-bottom: 20px;

  ${({ fixed }) => (fixed ? `
    height: 678px;
    border: 1px solid lightgrey;
    border-top: 0;
    border-radius: 8px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    overflow-y: scroll;
  ` : '')}


  @media (max-width: 768px) {
    max-height: 360px;
  }
`;

export const RowScheduleContainer = styled.div<{ realIndex: number }>`
  display: flex;
  flex-direction: row;
  margin-top: ${({ realIndex }) => (realIndex === 0 ? '32px' : '10px')};
  margin-left: 37px;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    margin-top: 4px;
    margin-left: 4px;
  }
`;
